import { render, staticRenderFns } from "./ResourceCenterLayout.vue?vue&type=template&id=7bb1803a&scoped=true&"
import script from "./ResourceCenterLayout.vue?vue&type=script&lang=js&"
export * from "./ResourceCenterLayout.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCenterLayout.vue?vue&type=style&index=0&id=7bb1803a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb1803a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
